<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card min-height">
      <div class="card-body">
        <div class="px-4 pb-4">
          <div class="row">
            <div class="col-3">
              <h2 class="card-title-desc">All Shipments</h2>
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-6" v-if="isUserStaff()">
              <button v-if="httpLoading" class="btn btn-dark me-1" :disabled="httpLoading">Loading</button>
              <div v-else class="d-flex">
                <date-picker v-model="selectedDate" range class="me-3"  placeholder="Select Dates to Generate Report"></date-picker>
                <button class="btn btn-info me-1 w-100" @click="downloadShipmentReport">Download Shipment Report</button>
              </div>
            </div>
          </div>
          <TableLoading v-if="shipments.page === 0"/>
          <div v-else>
            <shipment-table :columns="columns" :rows="shipments" :current-page="currentPage" @updateShipmentData="updateShipment" @onSearch="searchFn"/>
            <b-pagination
                v-model="currentPage"
                :total-rows="shipments.total"
                :per-page="perPage"
                size="lg"
                align="center"
                class="mt-3"
            />
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import ShipmentTable from "@/components/shipment/shipment-table";
import {ALL_SHIPMENTS} from "@/gql/stock";
import TableLoading from "@/components/TableLoading";
import {mapActions, mapGetters} from "vuex";
import moment from "moment";
import {errorToast} from "@/components/successToast";
import {downloadFileConfig} from "@/filters/downloadFileConfig";

export default {
  page: {
    title: "Shipment",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, ShipmentTable, PageHeader, Layout},
  name: "shipments",
  data() {
    return {
      title: "Shipment",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Shipment",
          active: true
        }
      ],
      shipments: {
        page: 0,
        objects: []
      },
      selectedDate: "",
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      columns: [
        {
          field: 'productId.productName',
          label: 'Product Name'
        },
        {
          field: 'productId.code',
          label: 'Product Code'
        },
        {
          field: 'orderId',
          label: 'B/L #'
        },
        {
          field: 'dateOrdered',
          label: 'Date In'
        },
        {
          field: 'expiryDate',
          label: 'Expiry Date'
        },
        {
          field: 'quantity',
          label: 'Qty'
        },
        {
          field: 'orderPrice',
          label: 'Purchase Price'
        },
        {
          field: 'initialStockQuantity',
          label: 'Initial Stock Qty'
        },
        {
          field: 'newStockQuantity',
          label: 'New Stock Qty'
        },
        {
          field: 'actions',
          label: 'Action'
        }
      ],
    }
  },
  apollo: {
    shipments: {
      query: ALL_SHIPMENTS,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          searchKeyword: this.searchKeyword
        }
      }
    }
  },
  watch: {
    currentPage(){
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  computed: {
    ... mapGetters({
      httpLoading: 'http/httpLoading',
      httpErrors: 'http/httpErrors'
    })
  },
  mounted() {
    this.currentPage = parseInt(this.$route.query.page) || 1
  },
  methods: {
    ... mapActions({
      generateShipmentsReport: 'http/generateShipmentsReport',
    }),
    updateShipment(){
      this.$apollo.queries.shipments.refetch()
    },
    searchFn(data){
      this.searchKeyword = data
    },
    async downloadShipmentReport(){
      if (this.selectedDate !== ''){
        const start = moment(this.selectedDate[0]).format('YYYY-MM-DD')
        const end = moment(this.selectedDate[1]).format('YYYY-MM-DD')
        const response = await this.generateShipmentsReport({'start': start, 'end': end})
        if(response.data.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
          downloadFileConfig(response, `Shipments ${start} - ${end} Report.xlsx`)
        }else {
          errorToast('Error generating shipments report')
        }
      }else {
        errorToast('Date selection cannot be blank')
      }
    }
  }

}
</script>

<style scoped>

</style>
